module.exports = __webpack_public_path__ + "img/dsci0053.ac3ce8dc.jpg";